import { GEN_MODELS } from './models';
import { setGenModel, useGenModel } from './genModelStore';

// The image-generation model picker for Phase 2: a segmented toggle over the three
// Nano Banana models, left (cheapest/fastest) to right (best/priciest). Its own
// component so RealImagesStep stays small; the choice is a browser preference kept in
// genModelStore. Disabled while a generation batch is running.
export function GenModelToggle({ disabled }: { disabled?: boolean }) {
  const selected = useGenModel();
  return (
    <div className="inline-flex overflow-hidden rounded-lg border border-slate-300">
      {GEN_MODELS.map((m, i) => {
        const active = m.id === selected;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => setGenModel(m.id)}
            disabled={disabled}
            aria-pressed={active}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-colors disabled:opacity-50 ${
              i > 0 ? 'border-l border-slate-300' : ''
            } ${
              active
                ? 'bg-blue-600 text-white'
                : 'bg-white text-slate-600 hover:bg-blue-50'
            }`}
          >
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ backgroundColor: active ? '#fff' : m.color }}
              aria-hidden
            />
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
